import { useContext, useEffect, useReducer, useState } from "react";
import { types } from "../types/types";
import { AutContext } from "./AutContext";
import { autReducer } from "./autReducer";
import { cfg } from "../../configuracion";
import { postLogin } from "../services/postLogin";
import { getResidenteIdioma } from "../services/getResidenteIdioma"

const inicializar = () => {
  const usuario = JSON.parse(
    localStorage.getItem(cfg.prefijoLocalStorage + "usuario")
  );
  return {
    sesionIniciada: !!usuario,
    usuario,
  };
};

const nombreCompleto = (usu) => {
  if (!usu) return "";
  let nombre = usu.nombre || "";
  if (nombre && usu.apellido1) {
    nombre += " " + usu.apellido1;
  }
  nombre = nombre || usu.nif;
  nombre = nombre || usu.correoe;
  nombre = nombre || "";
  return nombre;
};

const iniciales = (usu) => {
  if (!usu) return "";
  let iniciales = "";

  iniciales = usu.nombre ? usu.nombre[0] : "";
  iniciales = iniciales + (usu.apellido1 ? usu.apellido1[0] : "");
  iniciales = iniciales.toLocaleUpperCase();

  return iniciales;
};

export const AutProvider = ({ children }) => {
  const [autEstado, dispatch] = useReducer(autReducer, {}, inicializar);
  const [loading, setLoading] = useState(true);
  const [habilitadoA2f, setHabilitadoA2f] = useState(false);

  const updateSesion = (usu) => {
    const usuCompleto = {
      ...usu,
      nombreCompleto: nombreCompleto(usu),
      iniciales: iniciales(usu),
    };

    const action = {
      type: types.iniciar,
      payload: usuCompleto,
    };
    localStorage.setItem(
      cfg.prefijoLocalStorage + "usuario",
      JSON.stringify(usuCompleto)
    );
    dispatch(action);
  };

  const iniciarSesion = async (usuario, clave, tipo, a2f, fase) => {
    const idiomaCliente = sessionStorage.getItem('idiomaCliente') || 'es';

    try {
      const resp = await postLogin(usuario, clave, tipo, a2f, fase, idiomaCliente);
      sessionStorage.setItem("mensajeENSMostrado", "false");

      if (resp?.datos) {
        if (resp?.datos?.error) {
          // Mantener A2F activo si estamos en fase 2 y el error es de código inválido o caducado
          if (fase === 2 && (
              resp?.datos?.error.includes("CODIGO_A2F_INVALIDO") ||
              resp?.datos?.error.includes("CODIGO_A2F_CADUCADO")
          )) {
            setHabilitadoA2f(true);
            throw new Error(resp.datos.error);
          } else {
            setHabilitadoA2f(false);
            throw new Error(resp.datos.error);
          }
        }
        if (resp?.datos?.isA2f) {
          setHabilitadoA2f(true);
          return;
        }
      }
      if (resp?.error) {
        setHabilitadoA2f(false);
        throw new Error(resp.error);
      }
      setHabilitadoA2f(false);
      updateSesion(resp.datos);
    } catch (error) {
      if (fase === 2 && (
          error.message?.includes("CODIGO_A2F_INVALIDO") ||
          error.message?.includes("CODIGO_A2F_CADUCADO")
      )) {
        setHabilitadoA2f(true);
      } else {
        setHabilitadoA2f(false);
      }
      throw error;
    }
  };





  const cerrarSesion = () => {
    // Guardamos el valor del idioma del usuario, para sincronizarlo con el idioma cliente (!usuario).
    const idiomaActual = autEstado.usuario?.idioma;
    // Almacenamos el último idioma del usuario. para sincronizarlo con el idioma cliente.
    sessionStorage.setItem('idiomaCliente', idiomaActual);
    // Eliminamos al usuario del localStorage.
    localStorage.removeItem(cfg.prefijoLocalStorage + "usuario");
    sessionStorage.setItem("mensajeENSMostrado", "false");
    setHabilitadoA2f(false);
    dispatch({ type: types.cerrar });

    //window.location.href = '/';
  };

  useEffect(() => {
    const sincronizarIdiomaResidente = async () => {
      if (autEstado.usuario) {
        try {
          const idiomaActualizado = await getResidenteIdioma(
            autEstado.usuario.id,
            autEstado.usuario.idioma,
            autEstado.usuario.authToken
          );
  
          if (idiomaActualizado && autEstado.usuario.idioma !== idiomaActualizado) {
  
              const usuarioActualizado = {
                ...autEstado.usuario,
                idioma: idiomaActualizado,
              };
              updateSesion(usuarioActualizado);
              
                setLoading(false);

          } else {
            setLoading(false);
          }
        } catch (error) {
          console.error("Error al obtener el idioma del residente:", error);
          setLoading(false);
        }
      }
    };
  
    sincronizarIdiomaResidente();
  }, [autEstado.usuario]);

  // Nueva función para resetear el estado A2F
  const resetearEstadoA2F = () => {
    setHabilitadoA2f(false);
  };


  return (
    <AutContext.Provider value={{ ...autEstado, iniciarSesion, cerrarSesion, updateSesion, loading, habilitadoA2f, resetearEstadoA2F }}>
      {children}
    </AutContext.Provider>
  );
};
